import CarouselItem from './CarouselItem';

export default CarouselItem;
